import { ICompanyDataModel } from '../../../data-models/company.data-model';
import { IMetricsResponseDataModel } from '../../../data-models/metrics.data-model';

function calculateImpliedEquityValue(
  equityFmv: number | null | undefined,
  ownerShipPercentage: number | null | undefined
): number | null {
  if (!ownerShipPercentage || equityFmv == null) {
    return null;
  }
  return (equityFmv * 100) / ownerShipPercentage;
}

export function toCompanyDetailsVM(
  company: ICompanyDataModel,
  companyMetrics: IMetricsResponseDataModel | null
) {
  const metrics = companyMetrics?.metrics.at(0);

  return {
    ...company,
    _calculatedValues: {
      impliedEquityValue: calculateImpliedEquityValue(metrics?.equityFmv, metrics?.ownerShipPercentage),
    },
  };
}
export type CompanyDetailsPanelViewModel = ReturnType<typeof toCompanyDetailsVM>;

export function fromCompanyDetailsVM(
  viewModel: Partial<CompanyDetailsPanelViewModel>
): Partial<ICompanyDataModel> {
  const { _calculatedValues, ...company } = viewModel;

  return company;
}
